module.exports = __webpack_public_path__ + "static/assets/90e2ade0538c34c20cec414d3f343297.svg";